module.exports = __webpack_public_path__ + "img/welcome.a0247e3a.png";